exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-236e7d38]{text-transform:uppercase;font-weight:700;margin-bottom:30px;font-size:22px}.sub-filter+.sub-filter[data-v-236e7d38]{margin-top:6px}.sub-filter-title[data-v-236e7d38]{font-weight:700}.is-white[data-v-236e7d38]{text-decoration:underline;text-align:center}", ""]);

// exports
